export default __webpack_public_path__ + "static/media/mail.cade5ed9.svg";